<template>
  <div class="wrapper">
    <parallax
      class="page-header header-filter clear-filter header-small"
      parallax-active="true"
      :style="headerStyle"
    >
      <div class="container">
        <div class="md-layout">
          <div
            class="md-layout-item md-size-66 md-small-size-100 md-xlarge-size-80 mx-auto"
          >
            <h1 class="title text-center">
              Join AER
            </h1>
            <h4 class="title">
                To join AER, please download the form below. The submission address is stated in the application form
            </h4>
            <div class="md-layout-item md-size-66 md-small-100 mx-auto">
              <a href="/downloads/pdf/registration-form.pdf" target="_blank">
                <md-button
                  class="md-primary md-block"
                >
                  <md-icon>cloud_download</md-icon> Download Registration Form
                </md-button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </parallax>
    <div
      id="main-panel"
      class="main main-raised"
    >
      <div class="section">
        <div class="container">
          <div class="md-layout">
            <div
              class="md-layout-item md-size-66 md-small-size-100 mx-auto"
            >
              <h2 class="title">
                The Registration Process
              </h2>
              <md-steppers md-vertical>
                <md-step id="first" md-label="Application Submission">
                    Submission of application to Engineering Organisation or Technological Association of Home Country
                </md-step>
                <md-step id="second" md-label="Consolidation">
                  Applications will be forwarded by the Engineering Organisation or Technological Association of home country to the National Monitoring Committee (NMC) 
                </md-step>
                <md-step id="third" md-label="Approval">
                  National Monitoring Committee (NMC) via Country Registrar will present the names to AER Commission Meeting for apporval. Commission meetings are held twice a year. 
                </md-step>
                <md-step id="fourth" md-label="Endorsement">
                  Head commissioner will table to AFEO Governing Board for Endorsement
                </md-step>
                <md-step id="fifth" md-label="Confirmation">
                  National Monitoring Committee (NMC) will inform the applicant on the registration
                </md-step>
              </md-steppers>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>

import Mixins from "@/plugins/basicMixins";
export default {
    name: "Privacy",
    components: {
    },
    mixins: [Mixins.HeaderImage],
    bodyClass: "privacy-page",
    props: {
        image: {
            type: String,
            default: require("@/assets/img/hero5.jpg")
        }
    },
    data() {
        return {
        };
    },
    mounted() {
        this.leafActive();
        window.addEventListener("resize", this.leafActive);
        document.addEventListener("scroll", this.scrollListener);
    },
    beforeDestroy() {
        window.removeEventListener("resize", this.leafActive);
        document.removeEventListener("scroll", this.scrollListener);
    },
    methods: {
        leafActive() {
            if (window.innerWidth < 768) {
                this.leafShow = false;
            } else {
                this.leafShow = true;
            }
        }
    }
};
</script>